import { Link, useNavigate } from 'react-router-dom';
import { useAuthStore } from '../../store/authStore';
import apiClient from '../../lib/api/client';

/** Mobile top bar (hidden on desktop where the sidebar carries brand + logout). */
export default function Header() {
  const { user, clearAuth } = useAuthStore();
  const navigate = useNavigate();

  const handleLogout = async () => {
    try {
      await apiClient.post('/auth/logout');
    } catch (error) {
      console.error('Logout error:', error);
    } finally {
      clearAuth();
      navigate('/login');
    }
  };

  const name = user?.displayname || user?.nickname;

  return (
    <header className="sticky top-0 z-30 border-b-[2.5px] border-ink bg-paper lg:hidden">
      <div className="flex h-14 items-center justify-between px-5">
        <Link to="/app/dashboard" className="flex items-center gap-2.5">
          <span className="flex h-9 w-9 -rotate-3 items-center justify-center rounded-tile border-2 border-ink bg-marker text-base font-extrabold shadow-hard-sm">
            V
          </span>
          <span className="text-lg font-extrabold tracking-tight">Voc7</span>
        </Link>
        <div className="flex items-center gap-3">
          {name && <span className="hidden text-sm font-bold sm:inline">{name}</span>}
          <button
            onClick={handleLogout}
            className="h-10 rounded-tile border-2 border-ink bg-cream px-3 text-sm font-bold"
          >
            Abmelden
          </button>
        </div>
      </div>
    </header>
  );
}
